import React from "react";
import MotionReveal from "./MotionReveal";

export default function HomeProofStrip({ content }) {
  return (
    <section className="public-home-premium__proof-strip" aria-label="Differenz und Vertrauenssignale">
      <div className="mx-auto w-full max-w-page px-4 sm:px-6 lg:px-8">
        <MotionReveal className="public-home-premium__proof-surface" y={22}>
          <div className="public-home-premium__proof-surface-mark" aria-hidden="true">
            <span />
            <span />
          </div>
          <div className="public-home-premium__proof-shell">
            <div className="public-home-premium__proof-intro">
              <span className="public-home-premium__eyebrow">{content.eyebrow}</span>
              <p>
                {content.lead || "Verifikation, Dokumentenprüfung, Readiness und Arbeitgeberverantwortung werden früh operativ sichtbar."}
              </p>
            </div>
            <div className="public-home-premium__proof-rail">
              {content.items.map((item, index) => (
                <article key={item.title} className="public-home-premium__proof-item public-home-premium__proof-rail-item">
                  <div className="public-home-premium__proof-item-head">
                    <span className="public-home-premium__mini-label">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <i className="public-home-premium__proof-dot" aria-hidden="true" />
                  </div>
                  <strong>{item.title}</strong>
                  <p>{item.text}</p>
                </article>
              ))}
            </div>
          </div>
        </MotionReveal>
      </div>
    </section>
  );
}
